import { render, staticRenderFns } from "./detail-cell-renderer-vorgaenge.vue?vue&type=template&id=b0d76c88&scoped=true"
import script from "./detail-cell-renderer-vorgaenge.vue?vue&type=script&lang=js"
export * from "./detail-cell-renderer-vorgaenge.vue?vue&type=script&lang=js"
import style0 from "./detail-cell-renderer-vorgaenge.vue?vue&type=style&index=0&id=b0d76c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d76c88",
  null
  
)

export default component.exports